export default __webpack_public_path__ + "static/media/loading.417017f1.gif";